export enum routeTypeEnum {
  public = "public",
  private = "private",
}

export enum levelsEnum {
  one = 1,
  two = 2,
  three = 3,
  four = 4,
}

export type levels = 1 | 2 | 3 | 4;

export enum showInOptionsEnum {
  showInHeader = "showInHeader",
  showInFooter = "showInFooter",
  showInSidebar = "showInSidebar",
}
